import React from 'react';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';

export default function SimpleTest() {
  const testConnection = async () => {
    try {
      toast.loading('Testando conexão...', { id: 'test-connection' });
      
      console.log('🔍 Iniciando teste de conexão...');
      const { data, error } = await supabase.from('users').select('count').limit(1);
      
      if (error) {
        console.error('❌ Erro na conexão:', error);
        toast.error(`Erro: ${error.message}`, { id: 'test-connection' });
      } else {
        console.log('✅ Conexão bem-sucedida:', data);
        toast.success('Conexão bem-sucedida!', { id: 'test-connection' });
      }
    } catch (err) {
      console.error('❌ Exceção no teste:', err);
      toast.error(`Exceção: ${err.message}`, { id: 'test-connection' });
    }
  };
  
  const testAuth = async () => {
    try {
      toast.loading('Testando autenticação...', { id: 'test-auth' });
      
      console.log('🔍 Iniciando teste de autenticação...');
      const { data, error } = await supabase.auth.getSession();
      
      if (error) {
        console.error('❌ Erro na autenticação:', error);
        toast.error(`Erro: ${error.message}`, { id: 'test-auth' });
      } else {
        console.log('✅ Autenticação:', data);
        toast.success(`Sessão: ${data.session ? 'Ativa' : 'Inativa'}`, { id: 'test-auth' });
      }
    } catch (err) {
      console.error('❌ Exceção no teste de auth:', err);
      toast.error(`Exceção: ${err.message}`, { id: 'test-auth' });
    }
  };
  
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          EventPour - Página de Teste
        </h1>
        
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">
            ✅ React está funcionando!
          </h2>
          <p className="text-gray-600 mb-4">
            Se você está vendo esta página, o React está carregando corretamente.
          </p>
          
          <div className="flex space-x-4 mt-4">
            <button 
              onClick={testConnection}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Testar Conexão
            </button>
            
            <button 
              onClick={testAuth}
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            >
              Testar Autenticação
            </button>
          </div>
        </div>

        <div className="bg-blue-50 rounded-lg p-6 mb-6">
          <h3 className="font-semibold mb-2">Próximos passos:</h3>
          <ol className="list-decimal list-inside space-y-2 text-gray-700">
            <li>Acesse <a href="/login" className="text-blue-600 underline">/login</a> para testar o login</li>
            <li>Verifique o console (F12) para ver logs de debug</li>
            <li>Se esta página funciona mas o login não, o problema é na autenticação</li>
          </ol>
        </div>

        <div className="bg-green-50 rounded-lg p-6 mb-6">
          <h3 className="font-semibold mb-2">Status do Sistema:</h3>
          <div className="space-y-2 text-sm">
            <div className="flex items-center">
              <span className="w-3 h-3 bg-green-500 rounded-full mr-2"></span>
              React: Funcionando
            </div>
            <div className="flex items-center">
              <span className="w-3 h-3 bg-green-500 rounded-full mr-2"></span>
              Tailwind CSS: Funcionando
            </div>
            <div className="flex items-center">
              <span className="w-3 h-3 bg-green-500 rounded-full mr-2"></span>
              Roteamento: Funcionando
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <button
            onClick={() => window.location.href = '/login'}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Ir para Login
          </button>
          
          <button
            onClick={() => window.location.href = '/dashboard'}
            className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors"
          >
            Ir para Dashboard
          </button>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <h4 className="font-semibold text-yellow-800 mb-2">Debug Info:</h4>
          <div className="text-sm text-yellow-700 space-y-1">
            <div>URL atual: {window.location.href}</div>
            <div>Timestamp: {new Date().toLocaleString('pt-BR')}</div>
            <div>User Agent: {navigator.userAgent.substring(0, 30)}...</div>
            <div>Supabase URL: {import.meta.env.VITE_SUPABASE_URL ? 'Definida' : 'Fallback'}</div>
            <div>Supabase Key: {import.meta.env.VITE_SUPABASE_ANON_KEY ? 'Definida' : 'Fallback'}</div>
          </div>
        </div>
      </div>
    </div>
  );
}